import { useAppSelector } from "hooks/redux";
import { useCallback, useEffect, useState } from "react";
import { useBuilderMenuPanelState } from "components/builderShell/hooks/useBuilderMenuPanelState";

export type TWebsiteBuilderToolbarMenuType = "add-elements" | "add-sections" | "manage-pages" | "design" | "add-media" | "layers" | "none";

export interface IWebsiteBuilderToolbarState {
  menuType: TWebsiteBuilderToolbarMenuType;
  closingMenuPanel: boolean;
}

export type THandleSetToolbarMenuType = (menuType: TWebsiteBuilderToolbarMenuType) => void;

interface IUseWebsiteBuilderToolbarState {
  toolbarState: IWebsiteBuilderToolbarState;
  handleSetToolbarMenuType: THandleSetToolbarMenuType;
}

export function useWebsiteBuilderToolbarState(): IUseWebsiteBuilderToolbarState {
  const mode = useAppSelector(store => store.websiteBuilderStore.editor.mode);

  const [menuType, setMenuType] = useState<TWebsiteBuilderToolbarMenuType>("none");

  const { closing, requestSetActiveId } = useBuilderMenuPanelState<TWebsiteBuilderToolbarMenuType>({
    activeId: menuType,
    setActiveId: setMenuType,
    noneId: "none",
    blockActionsWhileClosing: true,
  });

  const handleSetToolbarMenuType = useCallback<THandleSetToolbarMenuType>(
    nextMenuType => {
      requestSetActiveId(nextMenuType);
    },
    [requestSetActiveId],
  );

  useEffect(() => {
    if (mode === "preview") {
      handleSetToolbarMenuType("none");
    }
  }, [mode, handleSetToolbarMenuType]);

  return {
    toolbarState: {
      menuType,
      closingMenuPanel: closing,
    },
    handleSetToolbarMenuType,
  };
}
